<template>
  <v-container fluid>

    <!-- <v-card min-height="calc(100vh - 150px)"> -->
      <div class="d-flex">
        <h3 class="secondary--text "><T>Информация о госте</T></h3>
        <v-spacer></v-spacer>
        <v-btn 
          v-if="checkedGuest" 
          text 
          color="success"
          @click="history_dialog = true"
        >
          <v-icon class="mr-1">mdi-sale-outline</v-icon>
          <T>История заказов</T>
        </v-btn>
        <v-bottom-sheet scrollable inset v-model="history_dialog" max-width="600" v-if="checkedGuest">
          <v-card height="600">
            <v-card-title><T>История заказов</T></v-card-title>
            <v-card-text>
              <GuestHistory v-model="guest"/>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>
        <v-btn 
          v-if="checkedGuest" 
          text 
          color="error"
          @click="drop_guest = true"
        >
          <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
          <T>Очистить</T>
        </v-btn>
        <v-dialog v-model="drop_guest" max-width="600">
          <v-card>
            <v-card-title><T>Очистка информации о госте</T></v-card-title>
            <v-card-text><T>Выбор гостя для текущего заказа будет отменен.</T><br><T>Внесенные изменения будут утрачены.</T><br><T>Очистить информацию о госте?</T></v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn type="reset" color="black" text @click="drop_guest = false"> <v-icon>mdi-close</v-icon><T>Отмена</T></v-btn>
              <v-btn color="error" text @click="() => { drop_guest = false; checkedGuest = undefined }"> <v-icon>mdi-close-circle-outline</v-icon><T>Очистить</T></v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <transition name="fade" duration="100" mode="out-in">
        <div :key="1" v-if="checkedGuest" class="mt-3">
          <v-row v-if="guest.black_list">
            <v-col>
              <v-banner single-line>
                <v-icon color="warning" size="36">mdi-alert-circle-outline</v-icon>
                <T>Пользователь</T> {{ guest.name }} <T>заблокирован. Вы можете посмотреть причину блокировки на странице гостя</T>
                <template v-slot:actions>
                  <v-btn color="primary" text @click="$router.push({name: 'Guest', params: {guestId: guest.id}})"><T>Посмотреть</T></v-btn>
                </template>
              </v-banner>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col>
              <InlinePhoneAppenderField 
                :items="guest.phones" 
                v-model="checkedPhone" 
                :default="guest.default_phone ? guest.phones.filter(el => el.id == guest.default_phone)[0] : undefined"
                ref="phoneField"
                @focus.prevent="e => $store.dispatch('inputFocus', e)"
                @removePhone="e => $emit('removePhone', e)"
                :rules="[rules.required, rules.phoneRule]"
              />
              <EditableInfoField fake_hint @focus.prevent="e => $store.dispatch('inputFocus', e)" kbd-capitalized :label="$t('ФИО гостя')" v-model="guest.name" :rules = "[rules.required, rules.nameRule(2)]"/>
            </v-col>
            <v-col>
              <EditableInfoField fake_hint kbd-layout="en_US_qwerty" @focus.prevent="e => $store.dispatch('inputFocus', e)" :label="$t('Адрес электронной почты')" v-model="guest.email" :rules = "[rules.emailRule]"/>
              <EditableInfoField fake_hint @focus.prevent="e => $store.dispatch('inputFocus', e)" :label="$t('Информация о госте')" v-model="guest.extra"/>
            </v-col>
            <v-col cols="12">
              <SelectField fake_hint item-value="code" :label="$t('Спец.скидка гостя')" :items="guest_discounts" style="min-height: 65px;" v-model="guest.discount"/>
            </v-col>
          </v-row>
          <InlineAddressAppenderField 
            v-if="checkedOrderType == 'delivery'"
            :items="guest.addresses"
            v-model="checkedAddress"
            :deliveryZone="deliveryZone"
            @deliveryZone="e => checkedDeliveryZone = e"
            :default="guest.default_address ? guest.addresses.filter(el => el.id == guest.default_address)[0] : undefined /* it`s ok to be undefined */"
            ref="addressField"
            @focus.prevent="e => $store.dispatch('inputFocus', e)"
            @removeAddress="e => $emit('removeAddress', e)"
          />
        </div>
        <div v-else :key="2" class="mt-3">
          <InlineGuestSearchField
            @input="onGuest"
          />
        </div>
      </transition>
    <!-- </v-card> -->
  </v-container>
</template>

<script>
import InlineAddressAppenderField from './InlineAddressAppenderField.vue'
import InlineGuestSearchField from './InlineGuestSearchField'
import EditableInfoField from '@/components/common/EditableInfoField.vue'
import SelectField from '@/components/common/SelectField.vue';
import InlinePhoneAppenderField from './InlinePhoneAppenderField.vue'
import GuestHistory from '../../../guests/GuestInfo/GuestHistory.vue';
import {mapGetters} from 'vuex'

import rules_mixin from '../../../common/rules_mixin'
// import GuestForm from '../GuestForm'
// import TextField from '../../../common/TextField'
// import InfoField from '@/components/common/InfoField.vue'
// import AddressSuggestionField from '../../../common/AddressSuggestionField'
// import Map from '../../../common/Map'
// import { LMarker } from 'vue2-leaflet'
// import ScrollerHandler from '@/components/scroller_handler'
// import PhoneField from '../common/PhoneField.vue'
// import CheckBox from '../common/CheckBox.vue'


export default {
  mixins: [rules_mixin],
  props: {
    address: [Object, undefined],
    phone: [Object, undefined],
    orderType: String,
    deliveryZone: [Object, undefined],
    guest: [Object, undefined]
  },
  data: () => ({
    local_loading: false,
    drop_guest: false,
    history_dialog: false,
    bottom_navigation: false,
    center: {lat: 55.7558, lng: 37.6173},
    zoom: 14,
    search_results: undefined,
    phones: ['+79639499629', '+79535339392']
  }),
  methods: {
    async onGuest(guest) {

      this.$store.dispatch('hideKeyboard')

      this.checkedGuest = guest

      if (guest.push_phone) {
        this.$emit('onPhone', guest.push_phone)
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.phoneField.focus()
          })
        }, 200)
      } else if (guest.phones.length === 1) {
        this.$emit('onPhone', guest.phones[0])
      } else if (guest.default_phone) {
        this.$emit('onPhone', guest.phones.filter(el => el.id === guest.default_phone)[0])
      } else {
        this.$emit('onPhone', { number: '' })
      }


      if (guest.addresses.length === 1) {
        this.$emit('onAddress', guest.addresses[0])
      } else if (guest.default_address) {
        this.$emit('onAddress', guest.addresses.filter(el => el.id === guest.default_address)[0])
      }
    },
  },
  watch: {
    value: {
      deep: true,
      handler(v) {
        this.$emit('input', v)
      }
    }
  },
  computed: {
    ...mapGetters(['zone_colors', 'config', 'references', 'guest_discounts']),
    zone_color(){
      if (this.delivery_zone && this.order_type === 'delivery') {
        return this.zone_colors[this.delivery_zone.idx % this.zone_colors.length]
      } else {
        return 'inherit'
      }
    },
    checkedOrderType() {
      return this.orderType
    },
    checkedGuest: {
      get() {
        return this.guest
      },
      set(v) {
        this.$emit('onGuest', v)
      }
    },
    checkedPhone: {
      get() {
        return this.phone
      },
      set(v) {
        this.$emit('onPhone', v)
      }
    },
    checkedAddress: {
      get() {
        return this.address
      },
      set(v) {
        this.$emit('onAddress', v)
      }
    },
    checkedDeliveryZone: {
      get() {
        return this.deliveryZone
      },
      set(v) {
        this.$emit('onDeliveryZone', v)
      }
    },
    discounts_ids(){
      return this.config.r_keeper_references.guest_discounts
    },
    discounts(){
      return this.references.order_discount_ref.filter(item => this.discounts_ids.includes(item.value))
    }
  },
  async mounted(){
    await this.$store.dispatch('loadReferences')
  },
  components: {
    // TextField,
    // InfoField,
    InlineGuestSearchField,
    EditableInfoField,
    InlinePhoneAppenderField,
    InlineAddressAppenderField,
    SelectField,
    GuestHistory
    // GuestForm,
    // AddressSuggestionField,
    // Map,
    // LMarker,
    // ScrollerHandler
    // PhoneField,
    // CheckBox,
  }
}
</script>